import React, { PureComponent } from "react";
import OverviewTable, { DataConvert } from "../home/layouts/OverviewTable";
import createColumns from "./columns";
import http from "@/http";
import { Button } from "antd";
import styles from "./index.module.less";
import Avatar from "../../components/Avatar";
import { baseUrl, downloadImg } from "@/utils/constant";
import { connect } from "dva";
const HttpUnit = http.tokiot.sys.unit.v2;
@connect(({ global }) => ({ user: global.user }))
class SelectUnit extends PureComponent {
  state = {
    unitList: {},
    rows: [],
  };
  lastSelectData = {};

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isUnitChange, unit } = this.props;
    if (isUnitChange && isUnitChange(prevProps.unit, unit)) {
      this.lastSelectData = { size: this.lastSelectData.size };
      this.refreshUnitList();
    }
  }

  refreshUnitList = () => {
    this.getUnitList(this.lastSelectData);
  };
  selectRow = (keys, rows) => {
    this.setState({ rows });
  };
  getUnitList = (data) => {
    const { unit } = this.props;
    if (!data.id && unit && unit.id && unit.id.length > 0) {
      data.id = unit.id;
    }
    data.type = `Unit`;
    if (data.share && data.share.length > 0) {
      switch (data.share) {
        case `onlyShare`:
          data.onlyShare = true;
          break;
        case `onlyUnit`:
          data.onlyUnit = true;
          break;
      }
      delete data.share;
    }
    HttpUnit.list(data).then((ret) => {
      this.lastSelectData = data;
      this.setState({ unitList: DataConvert(ret) });
    });
  };

  render() {
    const { user } = this.props;
    let unit = user.unit;
    const { unitList, rows } = this.state;
    const { routeProps } = this.props;
    const columns = createColumns(this, {});
    let canChangeState = rows && rows.length > 0;
    return (
      <div className={styles.main}>
        <div className={styles.avatarDiv}>
          <Avatar />
        </div>
        {unit ? (
          <div className={styles.titie}>
            {/* <img
              className={styles.image}
              src={downloadImg + unit.webLogo}
              alt=""
            /> */}
            <span className={styles.name}>{unit.siteName}</span>
          </div>
        ) : (
          ``
        )}
        <div className={styles.body}>
          <OverviewTable
            selectType={"radio"}
            rowKey={`id`}
            columns={columns}
            dataItems={unitList}
            onSearch={this.getUnitList}
            showNum
            searchPageSize={23}
            selectRow={this.selectRow}
            expandRowByClick={true}
            selectedRowKeys={rows.map((f1) => f1.id)}
            otherTableProps={{
              childrenColumnName: "childrenList",
              defaultExpandAllRows: true,
              expandRowByClick: true,
              onRow: (record) => {
                return {
                  onClick: (event) => {
                    this.setState({ rows: [record] });
                  }, // 点击行
                };
              },
            }}
            toolBarButtonGroup={
              <Button
                type="primary"
                disabled={!canChangeState}
                onClick={() => {
                  if (rows.length === 1) {
                    let item = rows[0];
                    window.location.href = `${window.location.origin}/enterprise/${item.id}/home`;
                  }
                }}
              >
                进入企业端
              </Button>
            }
          />
        </div>
      </div>
    );
  }
}

export default SelectUnit;
